import { FONT_WEIGHTS } from '@/styles'
import { SxProps } from '@mui/material'

interface PageContentStyles {
  wrapper: SxProps
  title: SxProps
  content: SxProps
}

export const pageContentStyles: PageContentStyles = {
  wrapper: {
    py: 3,
  },
  title: {
    typography: { xs: 'textXlSemibold', md: 'displayXsSemibold' },
    textAlign: 'center',
  },
  content: {
    '.content-header': {
      typography: 'textLgSemibold',
    },
    a: {
      textDecoration: 'underline',
    },
    ul: {
      pl: 4,
    },
    '*': {
      typography: 'textSm',
      strong: {
        fontWeight: FONT_WEIGHTS.SEMI_BOLD,
      },
    },
  },
}
